import {
  DataProviderServerSide as SharedDataProviderServerSide,
  type DataProviderServerSideProps as SharedDataProviderServerSideProps,
} from '@shared/ui/Table';
import type { RowData } from '@tanstack/react-table';
import type { AllTexts } from '@/feature/lang/types';
import { ConfigureColumnsAction } from './components/ConfigureColumns';

interface DataProviderServerSideProps<
  TData extends RowData,
> extends SharedDataProviderServerSideProps<TData, AllTexts> {
  enableColumnConfiguration?: boolean;
}

export const DataProviderServerSide = <TData extends RowData>({
  enableColumnConfiguration = false,
  toolbarControls,
  ...props
}: DataProviderServerSideProps<TData>) => (
  <SharedDataProviderServerSide<TData, AllTexts>
    {...props}
    toolbarControls={
      enableColumnConfiguration ? (
        <>
          {toolbarControls}
          <ConfigureColumnsAction />
        </>
      ) : (
        toolbarControls
      )
    }
  />
);
